import { gql } from "config/graphql";
import { IProfile, IUnderwritingAvailability, IUser } from "config/types";
import {
  CONSTELLATION_FIELDS,
  FEATURE_FLAG_FIELDS,
  UNDERWRITING_AVAILABILITY_FIELDS,
} from "gql/fragments";
import { gqlQuery } from "store/apollo";

interface IFetchPreVerifiedResponse {
  data: {
    me: IVerifiedInitialData;
  };
}

export const fetchPreVerifiedInitialData = (): Promise<IFetchPreVerifiedResponse> => {
  const query = gql`
    ${FEATURE_FLAG_FIELDS}
    query fetchPreVerifiedInitialData {
      me {
        id
        status
        emails {
          id
          email
          status
        }
        phoneNumbers {
          id
          mask
          status
          createdAt
        }
        state {
          id
          name
          alpha2
        }
        activeConstellations {
          activeInsuranceMembership {
            id
            coverageDetails {
              maximumApprovedCoverageAmount
              maximumApprovedTermDuration
              minimumApprovedCoverageAmount
              minimumApprovedTermDuration
              requestedCoverageAmount
              requestedTermDuration
              product {
                slug
              }
            }
            latestEstimateDatum {
              id
              termDuration
              termUnit
              amount
              health
              tobacco
              insuredsAgeAtTerm
              premiums {
                amount
                billingFrequency
              }
            }
          }
          createdAt
          featureFlags {
            ...FeatureFlagFields
          }
          id
          label
        }
      }
    }
  `;

  return gqlQuery<IFetchPreVerifiedResponse["data"]>({
    fetchPolicy: "no-cache",
    query,
  });
};

interface IVerifiedInitialData extends IUser, IUnderwritingAvailability, IProfile {}

interface IFetchVerifiedInitialResponse {
  data: {
    me: IVerifiedInitialData;
  };
}

export const fetchVerifiedInitialData = (): Promise<IFetchVerifiedInitialResponse> => {
  const query = gql`
    ${UNDERWRITING_AVAILABILITY_FIELDS}
    ${CONSTELLATION_FIELDS}
    query fetchVerifiedInitialData {
      me {
        ...UnderwritingAvailabilityFields
        activeConstellations {
          ...ConstellationFields
        }
        id
        age
        birthdate
        age
        status
        createdAt
        firstName
        lastName
        middleName
        suffix
        emails {
          email
          status
        }
        phoneNumbers {
          id
          phoneNumber
          createdAt
          mask
          status
        }
        activeAddress {
          formattedDisplay
          street1
          street2
          city
          state
          postalCode
          country {
            id
            name
            alpha2
            alpha3
            hasStates
            hasPostalCode
            postalCodeFormat
          }
          stateObject {
            id
            name
            alpha2
          }
        }
      }
    }
  `;

  return gqlQuery<IFetchVerifiedInitialResponse["data"]>({ query });
};
